const TissueOptions={
    'P21':{
        tissue:[
            {
                label:"Cotyledon",
                value:"Cotyledon",
            }
        ],
        time:[
            {
                label:"0h post-harvest of fresh cotyledons",
                value:"0h post-harvest of fresh cotyledons"
            },{
                label:"24h of low-temperature treatment post-harvest of fresh cotyledons",
                value:"24h of low-temperature treatment post-harvest of fresh cotyledons"
            },{
                label:"24h post-harvest of fresh cotyledons",
                value:"24h post-harvest of fresh cotyledons"
            },
            {
                label:"48h of low-temperature treatment post-harvest of fresh cotyledons ",
                value:"48h of low-temperature treatment post-harvest of fresh cotyledons "
            },
            {
                label:"48h post-harvest of fresh cotyledons",
                value:"48h post-harvest of fresh cotyledons"
            },
            {
                label:"72h of low-temperature treatment post-harvest of fresh cotyledons",
                value:"72h of low-temperature treatment post-harvest of fresh cotyledons"
            },
            {
                label:"72h post-harvest of fresh cotyledons",
                value:"72h post-harvest of fresh cotyledons"
            },{
                label:"96h of low-temperature treatment post-harvest of fresh cotyledons",
                value:"96h of low-temperature treatment post-harvest of fresh cotyledons"
            },{
                label:"96h post-harvest of fresh cotyledons",
                value:"96h post-harvest of fresh cotyledons"
            }
        ]
    },
    "P15":{
        tissue:[
            {
                label:"Plumule",
                value:"Plumule",
            }, 
        ],
        time:[
            {
                label:"the 12th day after pollination",
                value:"the 12th day after pollination"
            },{
                label:"the 15th day after pollination",
                value:"the 15th day after pollination"
            },{
                label:"the 18th day after pollination",
                value:"the 18th day after pollination"
            },
            {
                label:"the 24th day after pollination",
                value:"the 24th day after pollination"
            },
            {
                label:"the 9th day after pollination",
                value:"the 9th day after pollination"
            },
           
        ]
    },
    "P18":{
        tissue:[
                {
                    label:"Cotyledon",
                    value:"Cotyledon",
                }
        ],
        time:[
                {
                    label:"the 12th day after pollination",
                    value:"the 12th day after pollination"
                },{
                    label:"the 15th day after pollination",
                    value:"the 15th day after pollination"
                },{
                    label:"the 9th day after pollination",
                    value:"the 9th day after pollination"
                }
        ]
    },
    "USS15":{
        tissue:[
            {
                label:"Leaf",
                value:"Leaf",
            }
        ],
        time:[
            {
                label:"0h of submersion",
                value:"0h of submersion",
            },{
                label:"24h of submersion",
                value:"24h of submersion",
            },{
                label:"3h of submersion",
                value:"3h of submersion",
            },{
                label:"5d of submersion",
                value:"5d of submersion",
            },{
                label:"6h of submersion",
                value:"6h of submersion",
            }
        ]

    },
    "FLS12":{
        tissue:[
            {
                label:"Cotyledon",
                value:"Cotyledon",
            }
        ],
        time:[
               {
                   label:"0h post-harvest of lotus seeds",
                   value:"0h post-harvest of lotus seeds"
               },{
                   label:"12h post-harvest of lotus seeds",
                   value:"12h post-harvest of lotus seeds"
               },{
                   label:"24h post-harvest of lotus seeds",
                   value:"24h post-harvest of lotus seeds"
               },{
                   label:"6h post-harvest of lotus seeds",
                   value:"6h post-harvest of lotus seeds"
               }
        ]
    },
    "LFB15":{
        tissue:[
               {
                   label:"Bud",
                   value:"Bud",
               } 
        ],
        time:[
            {
                label:"S1",
                value:"S1"
            }
        ]
    },
    "PD21":{
        tissue:[
               {
                   label:"Cotyledon",
                   value:"Cotyledon",
               } 
        ],
        time:[
            {
                label:"the 12th day after pollination",
                value:"the 12th day after pollination"
            },{
                label:"the 15th day after pollination",
                value:"the 15th day after pollination"
            },{
                label:"the 18th day after pollination",
                value:"the 18th day after pollination"
            },{
                label:"the 21th day after pollination",
                value:"the 21th day after pollination"
            },{
                label:"the 24th day after pollination",
                value:"the 24th day after pollination"
            },{
                label:"the 6th day after pollination",
                value:"the 6th day after pollination"
            },{
                label:"the 9th day after pollination",
                value:"the 9th day after pollination"
            }
        ]
    },
    "SUSS9":{
        tissue:[
               {
                   label:"Germinated sprout",
                   value:"Germinated sprout",
               } 
        ],
        time:[
            {
                label:"10d of salt treatment",
                value:"10d of salt treatment"
            },{
                label:"before salt treatment",
                value:"before salt treatment"
            },
            {
                label:"parallel control",
                value:"parallel control"
            }
        ]
    },
    "FLSPS15":{
        tissue:[
               {
                   label:"Pericarp",
                   value:"Pericarp",
               } 
        ],
        time:[
               {
                   label:"0h post-harvest of fresh lotus seeds",
                   value:"0h post-harvest of fresh lotus seeds"
               },{
                   label:"24h post-harvest of fresh lotus seeds",
                   value:"24h post-harvest of fresh lotus seeds"
               },{
                   label:"48h post-harvest of fresh lotus seeds",
                   value:"48h post-harvest of fresh lotus seeds"
               },{
                   label:"72h post-harvest of fresh lotus seeds",
                   value:"72h post-harvest of fresh lotus seeds"
               },{
                   label:"96h post-harvest of fresh lotus seeds",
                   value:"96h post-harvest of fresh lotus seeds"
               }
        ]
    },
    "CRMMLP27":{
        tissue:[
               {
                   label:"Cotyledon",
                   value:"Cotyledon",
               } 
        ],
        time:[
               {
                   label:"0h post-harvest of fresh cotyledons",
                   value:"0h post-harvest of fresh cotyledons"
               } ,{
                   label:"24h of low-temperature treatment post-harvest of fresh cotyledons",
                   value:"24h of low-temperature treatment post-harvest of fresh cotyledons"
               },{
                   label:"24h post-harvest of fresh cotyledons",
                   value:"24h post-harvest of fresh cotyledons"
               },{
                   label:"48h of low-temperature treatment post-harvest of fresh cotyledons",
                   value:"48h of low-temperature treatment post-harvest of fresh cotyledons"
               },
               {
                   label:"48h post-harvest of fresh cotyledons",
                   value:"48h post-harvest of fresh cotyledons"
               },{
                   label:"72h of low-temperature treatment post-harvest of fresh cotyledons ",
                   value:"72h of low-temperature treatment post-harvest of fresh cotyledons "
               },{
                   label:"72h post-harvest of fresh cotyledons",
                   value:"72h post-harvest of fresh cotyledons"
               },{
                   label:"96h of low-temperature treatment post-harvest of fresh cotyledons",
                   value:"96h of low-temperature treatment post-harvest of fresh cotyledons"
               },{
                   label:"96h post-harvest of fresh cotyledons",
                   value:"96h post-harvest of fresh cotyledons"
               }
        ]
    },
    "SD12":{
        tissue:[
            {
                label:"Stamen",
                value:"Stamen",
            }
        ],
        time:[
            {
                label:"stamens on the day of flowering",
                value:"stamens on the day of flowering"
            },{
                label:"stamens one day after flowering",
                value:"stamens one day after flowering"
            },{
                label:"stamens one day before flowering",
                value:"stamens one day before flowering"
            },
            {
                label:"stamens two days after flowering",
                value:"stamens two days after flowering"
            }
        ]
    },
    "SUST12":{
        tissue:[
               {
                   label:"Plumule",
                   value:"Plumule",
               } 
        ],
        time:[
            {
                label:"12DAP lotus pod illumination",
                value:"12DAP lotus pod illumination"
            },{
                label:"12DAP shade treatment of lotus pod",
                value:"12DAP shade treatment of lotus pod"
            },{
                label:"18DAP lotus pod illumination",
                value:"18DAP lotus pod illumination"
            },{
                label:"18DAP shade treatment of lotus pod",
                value:"18DAP shade treatment of lotus pod"
            }
        ]
    },
    "D49":{
        tissue:[
            {
                label:"Cotyledon-DAP12",
                value:"Cotyledon-DAP12",
            }, {
                label:"Cotyledon-DAP15",
                value:"Cotyledon-DAP15",
            },{
                label:"Cotyledon-DAP9",
                value:"Cotyledon-DAP9",
            },
            {
                label:"Immature-receptacle",
                value:"Immature-receptacle",
            },
            {
                label:"Immature-stamen",
                value:"Immature-stamen",
            },
            {
                label:"Leaf",
                value:"Leaf",
            },
            {
                label:"Mature-receptacle",
                value:"Mature-receptacle",
            },{
                label:"Mature-stamen",
                value:"Mature-stamen",
            },{
                label:"Petal",
                value:"Petal",
            },
            {
                label:"Petiole",
                value:"Petiole",
            },{
                label:"Pollinated-carpel",
                value:"Pollinated-carpel",
            },{
                label:"rhizome apical meristem",
                value:"rhizome apical meristem",
            },
            {
                label:"rhizome elongation Zone",
                value:"rhizome elongation Zone",
            },{
                label:"rhizome Internode",
                value:"rhizome Internode",
            },
            {
                label:"Root",
                value:"Root",
            },{
                label:"Seed-coat-DAP12",
                value:"Seed-coat-DAP12",
            },{
                label:"Seed-coat-DAP18",
                value:"Seed-coat-DAP18",
            },
            {
                label:"Seed-coat-DAP6",
                value:"Seed-coat-DAP6",
            },{
                label:"unpollinated-carpel",
                value:"unpollinated-carpel",
            },{
                label:"Apical buds",
                value:"Apical buds",
            },{
                label:"rhizome (later swelling stage/internode)",
                value:"rhizome (later swelling stage/internode)",
            },
            {
                label:"rhizome (middle swelling stage/internode)",
                value:"rhizome (middle swelling stage/internode)",
            },{
                label:"rhizome (stolon/internode)",
                value:"rhizome (stolon/internode)",
            }
        ],
        time:[
            {
                label:"0h post-harvest of fresh cotyledons",
                value:"0h post-harvest of fresh cotyledons"
            },{
                label:"24h of low-temperature treatment post-harvest of fresh cotyledons",
                value:"24h of low-temperature treatment post-harvest of fresh cotyledons"
            },{
                label:"24h post-harvest of fresh cotyledons",
                value:"24h post-harvest of fresh cotyledons"
            },
            {
                label:"48h of low-temperature treatment post-harvest of fresh cotyledons ",
                value:"48h of low-temperature treatment post-harvest of fresh cotyledons "
            },
            {
                label:"48h post-harvest of fresh cotyledons",
                value:"48h post-harvest of fresh cotyledons"
            },
            {
                label:"72h of low-temperature treatment post-harvest of fresh cotyledons",
                value:"72h of low-temperature treatment post-harvest of fresh cotyledons"
            },
            {
                label:"72h post-harvest of fresh cotyledons",
                value:"72h post-harvest of fresh cotyledons"
            },{
                label:"96h of low-temperature treatment post-harvest of fresh cotyledons",
                value:"96h of low-temperature treatment post-harvest of fresh cotyledons"
            },{
                label:"96h post-harvest of fresh cotyledons",
                value:"96h post-harvest of fresh cotyledons"
            }
        ]
    },
}
export default TissueOptions